<template>
    <div>
        <div class="d-flex align-items-center mb-1">
            <button class="btn btn-outline-secondary btn-sm mr-1" v-on:click="$emit('back')">
                <feather-icon icon="ArrowLeftIcon" class="mr-50"/>Listeye Dön
            </button>
            <div>
                <h5 class="mb-0">{{ item.EmployeeFullName }}</h5>
                <small class="text-muted">{{ item.ExitDateStr }} · {{ item.ExitCauseName }}</small>
            </div>
        </div>

        <virtual-steper :steps="steps" v-model="step" class="mb-1"></virtual-steper>

        <!-- Adım 1: Arabuluculuk bilgisi + ödemeler (çıkış akışındaki bileşen; tamamla butonu gizli) -->
        <div v-if="step == 0">
            <employee-exit-mediation
                :task-id="item.ExitTaskId"
                :id="item.EmployeeId"
                hide-complete
                hide-prev />
            <div class="text-right mt-1">
                <button class="btn btn-primary" v-on:click="step = 1">Ödeme Gönderimine Geç</button>
            </div>
        </div>

        <!-- Adım 2: Sterling banka gönderimi (KYKM/maaş ödeme akışıyla aynı) -->
        <div v-else>
            <mediation-sterling-payment :exit-task-id="item.ExitTaskId" />
            <div class="text-right mt-1">
                <button class="btn btn-outline-secondary" v-on:click="step = 0">Arabuluculuk Bilgilerine Dön</button>
            </div>
        </div>
    </div>
</template>

<script>
import VirtualSteper from '@/components/VirtualSteper.vue'
import EmployeeExitMediation from '@/views/employee-operations/employee/components/step-6/components/job-exit/components/EmployeeExitMediation.vue'
import MediationSterlingPayment from './MediationSterlingPayment.vue'

export default {
    components:{
        VirtualSteper,
        EmployeeExitMediation,
        MediationSterlingPayment
    },
    props:{
        item:Object
    },
    data(){
        return {
            step:0,
            steps:[
                "Arabuluculuk",
                "Ödeme Gönderimi"
            ]
        }
    }
}
</script>
